module.exports = __webpack_public_path__ + "img/80a6e583a785e2c1ed7273c689071d8.c5374d96.png";